import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-630dc9fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "item-description" }
const _hoisted_3 = { class: "flex justify-between items-end mt-auto" }
const _hoisted_4 = { class: "item-image" }
const _hoisted_5 = {
  key: 1,
  class: "absolute inset-x-0 inset-y-x2"
}
const _hoisted_6 = { class: "absolute bottom-0 left-0 right-0 flex items-end justify-between sm:gap-x-x2" }

import { ProductLabelType, ProductSpotModel } from '@/types/productServerApi';
import OverlaySpotImage from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotImage.vue';
import OverlaySpotTitle from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotTitle.vue';
import OverlaySpotPrice from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotPrice.vue';
import ProductDetailUpsellAddToBasket from '@/shared/product/upsell/ui/ProductDetailUpsellAddToBasket.vue';
import { computed } from 'vue';
import useProductAngleImage from '@/shared/product/details/useProductAngleImage';
import ProductSplashLabels from '@/shared/product/splash/ui/ProductSplashLabels.vue';
import ProductSpotEnergyClassification from '@/shared/product/spot/ui/ProductSpotEnergyClassification.vue';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import ProductSpotCertifications from '@/shared/product/spot/ui/ProductSpotCertifications.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailUpsellItemRecommended',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ProductSpotModel,
}



const { getMaybeAngleImageSku } = useProductAngleImage();
const imageSku = computed<string>(() => getMaybeAngleImageSku(props.item.sku, props.item.imageProperties));
const filteredLabels = computed(() => props.item.labels?.filter((item) => item.type !== ProductLabelType.Customize));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(OverlaySpotTitle, {
        title: __props.item.name,
        class: "item-title",
        large: true
      }, null, 8, ["title"]),
      _createVNode(OverlaySpotPrice, {
        price: __props.item.price,
        class: "item-price",
        large: true
      }, null, 8, ["price"]),
      _createVNode(Breakpoints, null, {
        "max-sm": _withCtx(() => [
          _createVNode(ProductSpotEnergyClassification, {
            class: "mt-x1 mb-x2",
            "lighting-specification": __props.item.lightingSpecification
          }, null, 8, ["lighting-specification"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProductDetailUpsellAddToBasket, {
          class: "mt-auto",
          sku: __props.item.sku,
          quantity: __props.item.quantityMultiplier,
          "upsell-purchase-options": __props.item.purchaseOptions
        }, null, 8, ["sku", "quantity", "upsell-purchase-options"]),
        _createVNode(Breakpoints, null, {
          "min-md": _withCtx(() => [
            _createVNode(ProductSpotEnergyClassification, {
              "lighting-specification": __props.item.lightingSpecification
            }, null, 8, ["lighting-specification"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(OverlaySpotImage, {
        sku: _unref(imageSku),
        "cache-bust": __props.item.imageProperties.version
      }, null, 8, ["sku", "cache-bust"]),
      (__props.item.labels)
        ? (_openBlock(), _createBlock(ProductSplashLabels, {
            key: 0,
            labels: _unref(filteredLabels),
            recommended: true
          }, null, 8, ["labels"]))
        : _createCommentVNode("", true),
      (__props.item.certificates)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ProductSpotCertifications, {
                certificates: __props.item.certificates
              }, null, 8, ["certificates"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})